
import { Component, Vue, Prop } from 'vue-property-decorator';
import { namespace } from "vuex-class";   

import PageBase from "../PageBase.vue";
import LegalAssistanceFaq from "@/components/utils/LegalAssistanceFaq.vue";

import "@/store/modules/application";
const applicationState = namespace("Application");

import {stepsAndPagesNumberInfoType} from "@/types/Application/StepsAndPages";
import {stepInfoType, stepResultInfoType } from "@/types/Application";
import { otherFormInfoType } from '@/types/Application/OtherFamilyForm';
import { togglePages ,toggleSteps } from '@/components/utils/TogglePages';

@Component({
    components:{
        PageBase,
        LegalAssistanceFaq
    }
})
export default class OtherForms extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

    @applicationState.State
    public stPgNo!: stepsAndPagesNumberInfoType;

    @applicationState.State
    public rejectedPathway!: boolean;

    @applicationState.Action
    public UpdatePathwayCompleted!: (changedpathway) => void

    @applicationState.Action
    public UpdateApplicationType!: (newApplicationType: string[]) => void

    @applicationState.Action
    public UpdateStepResultData!: (newStepResultData: stepResultInfoType) => void      
    
    selectedForms: otherFormInfoType[] = [];
    filingMethod = null;
    showLegalAssistance = false;    
    disableNextButton = false;
    reloadPageInProgress = false;

    currentStep =0;
    currentPage =0;

    formList: otherFormInfoType[] = [
        {formName: 'Affidavit – General',                                   formNumber: 'Form 45'},
        {formName: 'Affidavit of Personal service',                         formNumber: 'Form 48'},
        {formName: 'Affidavit of Personal Service of Protection Order',     formNumber: 'Form 49'},
        {formName: 'Certificate of Service',                                formNumber: 'Form 7'},
        {formName: 'Consent adjournment',                                   formNumber: 'PFA920'},
        {formName: 'Consent Order',                                         formNumber: 'Form 18'},
        {formName: 'Consent to an Informal Trial (Kamloops only)',          formNumber: 'PFA709'},
        {formName: 'Electronic Filing Statement',                           formNumber: 'Form 51'},
        {formName: 'Fax Filing Cover Page',                                 formNumber: 'Form 52'},
        {formName: 'Financial Statement',                                   formNumber: 'Form 4'},
        {formName: 'Guardianship Affidavit',                                formNumber: 'Form 5'},
        {formName: 'Notice of Address Change',                              formNumber: 'Form 46'},
        {formName: 'Notice of Discontinuance',                              formNumber: 'Form 50'},
        {formName: 'Notice of Exemption from Parenting Education Program',  formNumber: 'Form 20'},
        {formName: 'Notice of Intention to Proceed',                        formNumber: 'Form 2'},
        {formName: 'Notice of Lawyer for Child',                            formNumber: 'Form 40'},
        {formName: 'Notice of Lawyer for Party',                            formNumber: 'Form 42'},
        {formName: 'Notice of Participation',                               formNumber: 'PFA747'},
        {formName: 'Notice of Removal of Lawyer for Child',                 formNumber: 'Form 41'},
        {formName: 'Notice of Removal of Lawyer for Party',                 formNumber: 'Form 43'},
        {formName: 'Order – General',                                       formNumber: 'Form 44'},
        // Removed "REF" in certificateGroup array as per https://jira.justice.gov.bc.ca/browse/PFCF-539
        // {formName: 'Referral Request',                                      formNumber: 'Form 21'},
        {formName: 'Request for Scheduling',                                formNumber: 'Form 39'},
        {formName: 'Request for Service of Documents',                      formNumber: 'PFA110'},
        {formName: 'Request for Service of Family Protection Order',        formNumber: 'PFA916'},
        {formName: 'Trial Readiness Statement',                             formNumber: 'Form 22'}
    ];

    fields = [        
        {
            key:"formName",    
            label:"Form Name",    
            sortable: true,    
            thClass: 'border-bottom align-middle text-center text-primary bg-info', 
            thStyle:{width: "40%"},
            tdClass:'align-middle text-left'},
        {
            key:"formNumber",  
            label:"Form Number",  
            sortable: true,    
            thClass: 'border-bottom align-middle text-center text-primary bg-info', 
            thStyle:{width: "60%"},
            tdClass:'align-middle text-left'}
                
    ]; 

    created() {
        this.disableNextButton = true;       
    }   

    mounted(){            
        this.reloadPageInformation();
    }

    public reloadPageInformation(){ 
        this.reloadPageInProgress = true;              
        this.currentStep = this.$store.state.Application.currentStep;
        this.currentPage = this.$store.state.Application.steps[this.currentStep].currentPage;

        if (this.step.result?.otherFormsSurvey?.data) {
            this.selectedForms = this.step.result.otherFormsSurvey.data.selectedOtherForms;
            this.filingMethod = this.step.result.otherFormsSurvey.data.filingMethod;
            this.determineSteps();
        }
        Vue.nextTick().then(()=>{this.selectForms(this.selectedForms)});
        
        this.disableNextButton = !this.allRequiredInfoExists();

        const progress = (this.filingMethod == null || this.selectedForms.length == 0)? 50 : 100;
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, false);
        setTimeout(()=>{this.reloadPageInProgress = false},5);
    }

    public selectForms(forms: otherFormInfoType[]){        

        const tableRef: any = this.$refs.formsTable;
        tableRef.clearSelected()

        for (const form of forms){
            const index = this.formList.findIndex((otherForm) => {if(otherForm.formName == form.formName)return true});
            tableRef.selectRow(index);            
        }

    }

    public onChangeFilingMethod(method){
        this.resetSteps();
        this.resetPages();
        this.determineSteps();
        this.disableNextButton = !this.allRequiredInfoExists();
        this.UpdatePathwayCompleted({pathway:"other", isCompleted:false})        
        // Vue.filter('surveyChanged')('other')        

    }

    public resetPages() { 

        const p = this.stPgNo.OTHER                              
        togglePages([p.CompleteOtherForms, p.OtherFormsFilingLocation], false, this.currentStep); 

        if(this.$store.state.Application.steps[this.currentStep].pages[p.CompleteOtherForms].progress>0)               
            Vue.filter('setSurveyProgress')(null, this.currentStep, p.CompleteOtherForms, 50, false);       

        if(this.$store.state.Application.steps[this.currentStep].pages[p.OtherFormsFilingLocation].progress>0) 
            Vue.filter('setSurveyProgress')(null, this.currentStep, p.OtherFormsFilingLocation, 50, false);
    }

    public resetSteps(){ //TODO add all new steps here    
        toggleSteps([this.stPgNo.SUBMIT._StepNo, this.stPgNo.NCD._StepNo, this.stPgNo.NDT._StepNo, this.stPgNo.NPR._StepNo, this.stPgNo.RQS._StepNo, this.stPgNo.TRIS._StepNo, this.stPgNo.NLC._StepNo, this.stPgNo.NLCR._StepNo, this.stPgNo.NLP._StepNo, this.stPgNo.NLPR._StepNo, this.stPgNo.AFF._StepNo, this.stPgNo.GA._StepNo, this.stPgNo.APS._StepNo, this.stPgNo.APSP._StepNo, this.stPgNo.CSV._StepNo, this.stPgNo.FS._StepNo], false);
    }

    public determineSteps(){
        const p = this.stPgNo.OTHER;
        togglePages([p.CompleteOtherForms], this.allRequiredInfoExists(), this.currentStep);
    }

    public onFormSelected(forms: otherFormInfoType[]){

        if(this.rejectedPathway){
            Vue.nextTick().then(()=>{this.selectForms(this.selectedForms)});
            return
        }

        this.selectedForms = forms;

        this.disableNextButton = !this.allRequiredInfoExists();

        const applicationTypes = []; 

        for (const form of forms){
            applicationTypes.push(form.formName);            
        }

        if (applicationTypes.includes('Fax Filing Cover Page')){
            this.filingMethod = 'inPerson';
        }
      
        this.UpdateApplicationType(Array.from(new Set(applicationTypes)));
        if(this.reloadPageInProgress)
            this.determineSteps();
        else
            this.onChangeFilingMethod(null)
    }
    
    public allRequiredInfoExists(){                
        return this.filingMethod != null && this.selectedForms.length > 0
    }    
    
    public onPrev() {
        Vue.prototype.$UpdateGotoPrevStepPage();
    }    

    public onNext() { 
        Vue.prototype.$UpdateGotoNextStepPage();
    }    
  
    beforeDestroy() {
        const progress = this.allRequiredInfoExists()?100:50;
        const pageData = {selectedOtherForms: this.selectedForms, filingMethod: this.filingMethod};
        Vue.filter('setSurveyProgress')(null, this.currentStep, this.currentPage, progress, true);         
        this.UpdateStepResultData({step:this.step, data: {otherFormsSurvey: {data: pageData, currentStep:this.currentStep, currentPage:this.currentPage}}});
    }
}
